module.exports = __webpack_public_path__ + "img/omilii-1775-pagina-de-titlu-big.33d63549.png";